import { Layout, Space, Typography } from "antd";
import React from "react";
import CustomHeader from "../components/common/Header";
import { useTranslation, Trans } from "react-i18next";
import {LOGO_SVG_URL } from "../constants/common";

const { Title } = Typography;

const Thanks = () => {
  const { Content, Footer } = Layout;
  const { t } = useTranslation();
  return (
    <Layout className="bg-white">
     <CustomHeader />
      <Content className="p-4 pb-0 md:p-6">
        <div className="container mx-auto followingl-list text-center md:text-left">
          <Space direction="vertical" className="w-full" size={30}>
            <Title
              level={1}
              className="font-bold text-center md:text-left"
              style={{
                fontSize: "1.5rem",
              }}
            >
              {t("common:thanks:thank_you")}
            </Title>
            <Title
              level={3}
              className="!font-normal text-center md:text-left"
              style={{
                fontSize: "0.938rem",
              }}
            >
              {t(
                "common:thanks:your_request_has_been_submitted_successfully_and_a_confirmation_email_has_been_sent_to_you"
              )}
            </Title>
            <Title
              level={3}
              className="!font-normal !mt-4 md:!mt-8 text-center md:text-left"
              style={{
                fontSize: "0.938rem"
              }}
            >
              <Trans
                i18nKey="common:thanks:confirmation_email_note"
                components={{
                  a: (
                    <a
                      href="mailto:requests@provider1st.com"
                      className="!underline !text-[#000000e0]"
                    />
                  ),
                }}
              />
            </Title>
          </Space>

          <Title
            level={3}
            className="mt-10 md:mt-20 text-center !font-semibold md:text-left"
            style={{  fontSize: "0.938rem" }}
          >
            <Trans
              i18nKey="common:thanks:assistance_call_text"
              components={{
                a: <a href="tel:855-514-2378" />,
                u: <u />,
              }}
            />
          </Title>
        </div>
      </Content>
      <Footer className="welcome-footer bg-white">
        <img
          alt="Provider1st Logo"
          className="m-auto"
          src={window.location.origin + LOGO_SVG_URL}
        />
      </Footer>
    </Layout>
  );
};

export default Thanks;
